// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uh_q","clinicsSelect":"styles_clinicsSelect__3K_ls"};